import { VehicleVersion } from '../models/vehicle-version';
import { InfocarEquipaggiamento } from './infocar-equipaggiamento';
import { InfocarQuotazioniVersione } from './infocar-quotazioni-versione';

export class InfocarVeicolo {
  marca: string;
  modello: string;
  allestimento: string;
  cilindrata: string;
  codiceInfocarAM: string;
  descrizioneCompleta: string;
  potenzaCV: string;
  potenzakW: string
  trasmissione: string;


  quotazione: InfocarQuotazioniVersione;
  /**
   * Lista degli quipaggiamenti esclusi 1 quellin comune a tutte le versioni 2 quelli con stato == 'O' 3 quelli con stato == 'S
   */
  equipaggiamenti: InfocarEquipaggiamento [] = [];
  equipaggiamentiTutti: InfocarEquipaggiamento [] = [];

  static infocarVeicoloToVehicleVersionDto(infocarVeicolo: InfocarVeicolo): VehicleVersion {
    let result = new VehicleVersion();

    result.make = infocarVeicolo.marca;
    result.model = infocarVeicolo.modello;
    result.mounting = infocarVeicolo.allestimento;
    result.engineCapacity = infocarVeicolo.cilindrata;
    result.infocarcodeAM = infocarVeicolo.codiceInfocarAM;
    result.description = infocarVeicolo.descrizioneCompleta;
    result.horsepower = infocarVeicolo.potenzaCV;
    result.kilowatt = infocarVeicolo.potenzakW;
    result.transmission = infocarVeicolo.trasmissione;

    result.quotes = InfocarQuotazioniVersione.infocarQuotazioniVersioneToVehicleVersionQuotesDto(infocarVeicolo.quotazione);

    if(infocarVeicolo.equipaggiamenti && infocarVeicolo.equipaggiamenti.length) {
      result.equipments = infocarVeicolo.equipaggiamenti.map(equip => InfocarEquipaggiamento.infocarEquipaggiamentoToVehicleEquipmentDto(equip));
    }
    if (infocarVeicolo.equipaggiamentiTutti && infocarVeicolo.equipaggiamentiTutti.length) {
      result.equipmentsAll = infocarVeicolo.equipaggiamentiTutti.map(equip => InfocarEquipaggiamento.infocarEquipaggiamentoToVehicleEquipmentDto(equip));
    }

    return result;
  }
}
